// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"193":"22d1f2e6c55723dd","195":"299c98d1c803ffd4","562":"887c56ac8f9fc67d","794":"6f501b115264f0d0","942":"64e5e565d69f0d06"}[chunkId] + ".js";
};